import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const endPoint = 'getDmNotificationStatus/';
const url = apiUrl + endPoint;

export interface GetDmNotificationStatusRequest {
  OrgUUID: string;
}

export interface GetDmNotificationStatusResponse {
  DmEnabled: boolean;
  Error: string | null;
}

const getDmNotificationStatus = async (
  req: GetDmNotificationStatusRequest,
  headerObj: headerObject
): Promise<GetDmNotificationStatusResponse | null> => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrgUUID: req.OrgUUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    return data;
  } catch (err) {
    console.error('Error getting DM notification status:', err);
    return null;
  }
};

export default getDmNotificationStatus;
